import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable'
import React from 'react';
import ReactDOM from 'react-dom';
import RouteConfig from './router/index';
import './util/reset.less';
import intl from 'react-intl-universal'
import { getCookie } from './util/cookie';

const rootDom = document.querySelector('#root');
let lang = React.$lang = getCookie('language') || 'en';

//设置埋点信息
// spm-a
let spma = document.querySelector('meta[name="spm-a"]');
if (!!spma) {
	spma.setAttribute("content", `pc${lang}`);
}

// spm-b
var parentBody = window.parent.document.getElementsByTagName('body');
var parentSPMB = parentBody[0].getAttribute('spm-b') || '';
document.body.setAttribute('spm-b', !!parentSPMB ? parentSPMB+"cart" : 'expresscart');

// event-code
document.body.setAttribute('event-code', "eSSc1uZnjz1c");

// ab-version
try {
  //如果cookie不存在，请求一次D1接口
  let utcTime = getCookie('abversions')||'';
  let abv_pv = getCookie('abversions_pv') || '';
  if(!(utcTime && new Date(JSON.parse(utcTime).utc*1000) > new Date()) || !abv_pv){
    //发请求
    let logImg = new Image();
    logImg.onload =function(){};
    logImg.src = 'https://abtest.dhgate.com/abversion_pv?exp_type=4&vid='+getCookie('vid')+"&timestamp="+new Date().getTime();
  }

  //上报分流
  let ABVersion = getCookie('abversions') || '';
  let ABVarr = [], ABVstr = '';

  ABVersion = ABVersion ? JSON.parse(ABVersion) : {};

  //留样例 分流id:162
  // if(ABVersion.hasOwnProperty('162')){
  //     ABVarr.push(`162_${ABVersion['162']}`);
  // }

  ABVstr = ABVarr.join('|');
  document.body.setAttribute('ab-version', ABVstr);
} catch (error) {}


// spm-c
rootDom.setAttribute('spm-c', 'expresscart')
rootDom.setAttribute('async-exposure', 'true')

//引入埋点SDK
try {
  let ss = document.createElement('script');
  ss.type = 'text/javascript';
  ss.defer = true;
  ss.src = '//js.dhresource.com/buyer/common/track/trackwebsdk.js?v=20250616';
  document.body.appendChild(ss);

} catch (error) {}


const locales = {
  'ar': require('./locales/ar.json'),
  'de': require('./locales/de.json'),
  'en': require('./locales/en.json'),
  'es': require('./locales/es.json'),
  'fr': require('./locales/fr.json'),
  'it': require('./locales/it.json'),
  'kr': require('./locales/kr.json'),
  'pt': require('./locales/pt.json'),
  'ru': require('./locales/ru.json'),
  'tr': require('./locales/tr.json'),
  'ie': require('./locales/ie.json'),
  'jp': require('./locales/jp.json'),
  'nl': require('./locales/nl.json'),
  'pl': require('./locales/pl.json'),
  'se': require('./locales/se.json'),
}

//如果不是以下已知的语言站点都默认为en
if( !['ar', 'de', 'en', 'es', 'fr', 'ie', 'it', 'jp', 'kr', 'nl', 'pl', 'pt', 'ru', 'se', 'tr'].includes(lang) ) {
  lang = React.$lang = 'en';
}

React.$site = lang === 'en' ? 'https://www.dhgate.com/' : 'https://'+lang+'.dhgate.com/';

// init intl must before render
intl.init({
  currentLocale: lang,
  locales
})


ReactDOM.render(
  <RouteConfig />,
  document.getElementById('root')
);
